
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ToggleInput',
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    toggleClass: {
      type: String,
      default: ''
    },
    removeYPadding: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get(): string | number | boolean {
        return this.value
      },
      set(value: string | number | boolean) {
        this.$emit('input', value)
      }
    }
  }
})
